import DirectDepositFormScreen from 'features/directDeposit/screens/DirectDepositFormScreen';
import React from 'react';

export default function DirectDepositFormPage() {
  return <DirectDepositFormScreen />;
}
